import { ACADEMIC_PAGES } from "./sitePagesAcademics.js";
import { ADMISSIONS_PAGES } from "./sitePagesAdmissions";
import { GENERAL_PAGES } from "./sitePagesGeneral";

export const SITE_PAGES = [
  ...ACADEMIC_PAGES,
  ...ADMISSIONS_PAGES,
  ...GENERAL_PAGES,
];
